<template>
    <div class="px-3 py-2">
        <b-table v-if="!error"
                 :busy="fetching"
                 :items="rows"
                 :fields="columns"
                 class="shx-table w-100"
                 hover dark fixed small
                 sort-icon-left
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc">

            <template #cell(admissions)="data">
                <span>{{ formatInt(data.item.admissions) }}</span>
            </template>

            <template #cell(real_weighted)="data">
                <span v-if="bucket === 'week'">
                    {{ data.item.real_weighted !== null ? data.item.real_weighted + '%' : '—' }}
                </span>
                <span v-if="bucket === 'week' && data.item.real_weighted !== null && data.item.real_weighted <= 90"
                      class="badge badge-warning ml-1"
                      :title="'Minimum real: ' + data.item.real_min + '%'">⚠</span>
            </template>

            <template #cell(actions)="data">
                <button @click="data.toggleDetails" class="btn btn-link btn-sm">
                    <icon :name="'chevron-' + (data.detailsShowing ? 'up' : 'down')"/>
                </button>
            </template>

            <template #row-details="data">
                <admissions-titles-table :bucket="bucket"
                                         :parent-key="parentKey"
                                         :theatre-code="data.item.theatre_code"
                                         :saleshouse="saleshouse"/>
            </template>

            <template #table-busy>
                <table-spinner/>
            </template>
        </b-table>

        <div v-if="error" class="text-center text-muted py-3">{{ error }}</div>
        <div v-else-if="!fetching && !rows.length" class="text-center text-muted py-3">No cinemas.</div>
    </div>
</template>

<script>
import {BTable} from "bootstrap-vue";
import axios from "axios";
import TableSpinner from "./TableSpinner";
import AdmissionsTitlesTable from "./AdmissionsTitlesTable";

export default {
    name: "AdmissionsCinemasTable",
    components: {
        AdmissionsTitlesTable,
        TableSpinner,
        BTable,
    },
    props: {
        bucket: {type: String, required: true, validator: v => ['day', 'week'].includes(v)},
        parentKey: {type: String, required: true},
        saleshouse: {type: String, default: null},
    },
    data() {
        const cols = [
            {key: 'theatre_code', label: 'Code', sortable: true, thClass: 'shx-th-80'},
            {key: 'theatre_name', label: 'Cinema', sortable: true},
            {key: 'city', label: 'City', sortable: true, thClass: 'shx-th-140'},
            {key: 'admissions', label: 'Admissions', sortable: true, thClass: 'text-right', tdClass: 'text-right'},
            {key: 'titles', label: '# Titles', sortable: true, thClass: 'text-right shx-th-100', tdClass: 'text-right'},
        ];

        if (this.bucket === 'week') {
            cols.push({key: 'real_weighted', label: 'Real %', sortable: true, thClass: 'text-right shx-th-100', tdClass: 'text-right'});
        }
        cols.push({key: 'actions', label: '', thClass: 'shx-th-60', tdClass: 'p-0 text-center align-middle'});

        return {
            fetching: false,
            rows: [],
            error: null,
            columns: cols,
            sortBy: 'admissions',
            sortDesc: true,
        };
    },
    mounted() {
        this.fetch();
    },
    watch: {
        saleshouse() {
            if (this.bucket === 'week') {
                this.fetch();
            }
        },
    },
    methods: {
        fetch() {
            this.fetching = true;
            this.error = null;

            const url = `/admissions/${this.bucket}/${this.parentKey}/cinemas`;
            const params = this.bucket === 'week' ? {saleshouse: this.saleshouse} : {};

            axios
                .get(url, {params})
                .then(response => {
                    this.rows = response.data.data.rows || [];
                })
                .catch(err => {
                    this.error = err.message || 'Failed to load cinemas.';
                })
                .finally(() => {
                    this.fetching = false;
                });
        },
        formatInt(v) {
            return (v || 0).toLocaleString();
        },
    }
}
</script>
